import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

export default function TenantGate({ children }) {
  const location = useLocation();

  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const [ready, setReady] = useState(() => {
    const hasStored =
      !!localStorage.getItem("tenantName") && !!localStorage.getItem("tenantEmail");
    const hasQuery = !!params.get("tenant_name") && !!params.get("tenant_email");
    return hasStored || hasQuery;
  });

  useEffect(() => {
    const qpName = params.get("tenant_name");
    const qpEmail = params.get("tenant_email");

    if (qpName) localStorage.setItem("tenantName", qpName);
    if (qpEmail) localStorage.setItem("tenantEmail", qpEmail);

    const tenantName = qpName || localStorage.getItem("tenantName");
    const tenantEmail = qpEmail || localStorage.getItem("tenantEmail");

    if (!tenantName || !tenantEmail) {
      window.location.href = `${process.env.REACT_APP_SITE_URL}/login`;
      return;
    }

    setReady(true);
  }, [params]);

  if (!ready) {
    return (
      <div className="container-fluid py-5">
        <div className="d-flex justify-content-center align-items-center min-vh-50">
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              style={{ width: "3rem", height: "3rem" }}
            />
            <div className="h5 text-gray-800">Loading your workspace…</div>
            <p className="text-muted small mt-2">
              Preparing tenant session
            </p>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

